<template>
  <section class="row">
    <div class="col-12">
      <div
        class="p-md-4 d-flex flex-column flex-md-row"
      >
        <div class="d-flex flex-column text-left">
          <div class="mb-2">
            {{ company.name.toUpperCase() }}
          </div>
          <div class="text-gray-500 mb-2 mb-md-0">
            {{ formattedPaymentMethod }}
          </div>
        </div>
        <div class="d-flex flex-column ms-md-auto text-gray-500">
          <div
            v-if="paymentMethod.type === 'CARD'"
            class="mb-2"
          >
            Expire le {{ expirationDate }}
          </div>
          <div>
            {{ brand }}
          </div>
        </div>
        <div class="d-flex ms-md-auto mt-2 my-md-auto">
          <slot>
            <v-loader
              :title="`Payer ${formatPrice}`"
              :next="payoutTransaction"
              class="w-100"
            />
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import { debounce } from 'lodash-es';

import { ui } from '@/mixins';

export default {
  name: 'PaymentMethodDisplay',
  mixins: [ui],
  props: {
    stripe: {
      type: Object,
      default: () => ({}),
    },
    price: {
      type: Number,
      required: true,
      default: 0,
    },
    paymentMethod: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      debouncer: { cancel: () => {} },
    };
  },
  computed: {
    ...mapGetters({
      company: 'company/get',
      transaction: 'checkout/transaction',
    }),
    formatPrice() {
      const formattedPrice = parseFloat(this.price || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
      return `${formattedPrice} €`;
    },
    isActive() {
      return this.paymentMethod.active;
    },
    formattedPaymentMethod() {
      if (this.paymentMethod.type === 'IBAN') {
        const { lastNumbers, countryCode } = this.paymentMethod;
        return `${countryCode}***********************${lastNumbers}`;
      }
      return `N° **** **** **** ${this.paymentMethod.lastNumbers}`;
    },
    expirationDate() {
      return this.paymentMethod.expirationDate;
    },
    brand() {
      return (this.paymentMethod.brand || 'SEPA').toUpperCase();
    },
  },
  methods: {
    async deleteCard(paymentMethodId) {
      if (this.isActive) { return Promise.resolve() }
      await this.$store.dispatch('payments/removeCreditCard', paymentMethodId);
      this.ui_showModal(true);
    },
    async payoutTransaction() {
      await this.$store.dispatch('payments/activatePaymentMethodFromId', this.paymentMethod.id);
      await this.$store.dispatch('checkout/instantPayment', {
        transactionId: this.transaction.id,
        paymentMethodId: this.paymentMethod.id,
        stripe: this.stripe,
      });
      return this.$router.push('/client/confirmation');
    },
    deleteAction() {
      this.isLoading = true;
      this.debouncer.cancel();
      const toBeCalled = async () => {
        try {
          await this.deleteCard(this.paymentMethod.id);
          await this.$store.dispatch('payments/getPaymentMethods');
        } finally {
          this.isLoading = false;
        }
      };
      this.debouncer = debounce(toBeCalled, 600);
      this.debouncer();
    },
  },
};
</script>
